import { __makeTemplateObject } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { keyframes } from '@emotion/react';

var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var TextInputWrap = styled.div(function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b;
    return {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        "&::after": loading
            ? {
                content: '""',
                boxSizing: "border-box",
                position: "absolute",
                right: tokens.spacing[5],
                bottom: 0,
                width: tokens.spacing[5],
                height: tokens.spacing[5],
                marginBottom: "18px",
                borderRadius: "50%",
                border: "2px solid ".concat(tokens.color.airJordan[400]),
                borderTopColor: "transparent",
                animation: "".concat(spin, " 1s linear infinite"),
            }
            : {},
    };
});
var Input = styled.input(function (_a) {
    var hasError = _a.hasError, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var borderColor = tokens.color.airJordan[400];
    if (hasError) {
        borderColor = tokens.color.roshe[600];
    }
    else if (disabled) {
        borderColor = "transparent";
    }
    var backgroundColor = disabled
        ? tokens.color.superstar.p
        : tokens.color.yeezy[0];
    var color = disabled
        ? tokens.color.airJordan[400]
        : tokens.color.airJordan.p;
    return {
        boxSizing: "border-box",
        borderRadius: tokens.borderRadius.m,
        fontSize: tokens.fontSize[3],
        border: "".concat(tokens.borderWidth.xs, " solid ").concat(borderColor),
        backgroundColor: backgroundColor,
        color: color,
        transition: "0.2s border",
        fontFamily: tokens.fontFamilies.primary,
        height: "56px",
        pointerEvents: disabled ? "none" : "initial",
        position: "relative",
        "::-webkit-search-cancel-button": {
            display: "none",
        },
        "&:focus": {
            outline: "none",
            borderColor: hasError
                ? tokens.color.roshe[600]
                : tokens.color.airJordan[800],
        },
        "&[readonly]:hover": {
            cursor: "text",
        },
    };
});
var templateObject_1;

export { Input, TextInputWrap };
//# sourceMappingURL=TextInput.styles.js.map
